import { useQuery } from '@tanstack/react-query';
import { fetchTesterQueue } from './api';

/**
 * Polls the Activity tester-queue endpoint via React Query.
 *
 * Mirrors `useMultiJobPolling.ts`'s pattern from `packages/web/`: 5s refetch
 * interval, refetch-in-background so the queue stays warm while the user
 * watches another voice channel member's screen-share, retry-once on transient
 * failures.
 */
export function useTesterQueue(accessToken: string | undefined) {
  return useQuery({
    queryKey: ['discord-activity-queue'],
    queryFn: () => fetchTesterQueue(accessToken!),
    enabled: Boolean(accessToken),
    refetchInterval: 5_000,
    refetchIntervalInBackground: true,
    retry: 1,
    staleTime: 0,
  });
}
